import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { isAdmin } from '../utils/roles';

export const Route = createFileRoute('/settings')({
  beforeLoad: ({ context, location }) => {
    if (!isAdmin(context.auth.user?.role)) {
      throw redirect({ to: '/project-settings/employee-project-models' });
    }
    const p = location.pathname;
    if (p === '/settings' || p === '/settings/') {
      throw redirect({ to: '/settings/employees' });
    }
  },
  component: SettingsLayout,
});

function SettingsLayout() {
  return <Outlet />;
}
